import React from 'react'
import { TooltipPopOver } from '@ztechapps/webui.util'
import { Body } from './Body'
import { useProductTooltipPopOverContext } from './Context'

export const Layout = ({ children }: { children: React.ReactElement }) => {
  const context = useProductTooltipPopOverContext()

  return (
    <TooltipPopOver tooltipBody={<Body />} {...context}>
      {children}
    </TooltipPopOver>
  )
}
